import {WebCallService} from "@/utilities/system/services/WebCallService";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {PlantRequest} from "@/models/api/requests";
import {Plant} from "@/models/entities/plants/Plant";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";

export class PlantService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getPlants(errorLocationType:ErrorLocationType):Promise<Array<Plant>|null> {
        const uri = this.uriHelper.plants.getPlantsPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async getPlantById(id:string, errorLocationType:ErrorLocationType):Promise<Plant|null> {
        const uri = this.uriHelper.plants.getPlantByIdPath(id);

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async addOrUpdatePlant(plant:Plant, errorLocationType:ErrorLocationType):Promise<Plant|null> {
        const uri = NullOrUndefinedHelper(plant.id)
            ? this.uriHelper.plants.getPlantsPath()
            : this.uriHelper.plants.getPlantByIdPath(plant.id);

        const requestBody = new PlantRequest(plant);

        const reqType = NullOrUndefinedHelper(plant.id)
            ? HttpType.post
            : HttpType.put;

        const resp = await this.webCaller.HttpSend(reqType, uri, requestBody);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async deletePlant(id:string, errorLocationType:ErrorLocationType):Promise<""|null> {
        const uri = this.uriHelper.plants.getPlantByIdPath(id);

        const resp = await this.webCaller.HttpSend(HttpType.delete, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async postPlantCsvImport(file:File, errorLocationType:ErrorLocationType):Promise<{}|null> {
        const uri = this.uriHelper.plants.getPlantImportPath();
        const requestBody = new FormData();
        requestBody.append("locationCsvFile", file);

        const resp = await this.webCaller.HttpSend(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp
    }
}